export const classicAppreciationFrame = () => ({
  id: 'classic-appreciation-frame',
  name: 'Classic Appreciation Frame',
  thumbnail: '/assets/diploma-templates/01_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#fffdf9',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/01_background.svg',
      key: null
    }
  }
});
